document.addEventListener('turbolinks:load', function () {
    $('.eyes-icon').on('click', function () {
        let user_password_field = $(this).parent().find('#password, #password_confirmation, #user_password, #user_password_confirmation, #old_password, #new_password');
        if (user_password_field.attr('type') === 'password') {
            user_password_field.attr('type', 'text')
        } else {
            user_password_field.attr('type', 'password')
        }
    })
})